<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="cu_code,cu_name"
      placeholder="输入代理编号、名称进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/document/agent/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.cu_name}}</p>
          <p class="list-item-muted">{{item.cu_type}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.cu_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.cu_audit_status=='已审核'}"
          >{{item.cu_audit_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}个</label>
    </div>
    <add-button to="/document/agent_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/document/customer/list",
      filters: [
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "ifnull(cu_kind,'Customer')='Distributor'"
            },
            {
              value: 1,
              label: "待审核",
              condition: "cu_audit_status='未审核' and ifnull(cu_kind,'Customer')='Distributor'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "cu_audit_status='已审核' and ifnull(cu_kind,'Customer')='Distributor'"
            }
          ]
        }
      ]
    };
  }
};
</script>